export default [    //代理商
  {
    path: "/agentList",  //代理商列表
    name: 'agentList',
    component: () => import("@/views/agent/agentList.vue")
  },
  {
    path: "/agentDetail",   //代理商详情
    name: 'agentDetail',
    component: () => import("@/views/agent/agentDetail.vue")
  },
  {
    path: "/agentAdd",   //创建代理商
    name: 'agentAdd',
    component: () => import("@/views/agent/agentAdd.vue")
  },
  {
    path: "/agentChoice",   //创建代理商
    name: 'agentChoice',
    component: () => import("@/views/agent/agentChoice.vue")
  }
]
